enum SubscriptionDataSource {
  ac3 = "ac3",
  adaptimmo = "adaptimmo",
  activimmo = "activimmo",
  agenceplus = "agenceplus",
  apimo = "apimo",
  big = "big",
  brevo = "brevo",
  c21 = "c21",
  excel = "excel",
  hektor = "hektor",
  hubspot = "hubspot",
  maxwork = "maxwork",
  septeo = "septeo",
  mykw = "mykw",
  naxos = "naxos",
  omnicasa = "omnicasa",
  other = "other",
  outilinterne = "outilinterne",
  prospeneo = "prospeneo",
  sweepbright = "sweepbright",
  unova = "unova",
  whise = "whise"
}

export const subscriptionDataSourceAsString = (
  susbcriptionDataSource: SubscriptionDataSource
): string => {
  switch (susbcriptionDataSource) {
    case SubscriptionDataSource.ac3:
      return 'AC3';
    case SubscriptionDataSource.adaptimmo:
      return 'Adaptimmo';
    case SubscriptionDataSource.activimmo:
      return 'Activimmo';
    case SubscriptionDataSource.agenceplus:
      return 'Agence Plus';
    case SubscriptionDataSource.apimo:
      return 'Apimo';
    case SubscriptionDataSource.big:
      return 'Big';
    case SubscriptionDataSource.brevo:
      return 'Brevo';
    case SubscriptionDataSource.c21:
      return 'C21';
    case SubscriptionDataSource.excel:
      return 'Excel';
    case SubscriptionDataSource.hektor:
      return 'Hektor';
    case SubscriptionDataSource.hubspot:
      return 'Hubspot';
    case SubscriptionDataSource.maxwork:
      return 'Maxwork';
    case SubscriptionDataSource.septeo:
      return 'Septeo';
    case SubscriptionDataSource.mykw:
      return 'MyKW';
    case SubscriptionDataSource.naxos:
      return 'Naxos';
    case SubscriptionDataSource.omnicasa:
      return 'Omnicasa';
    case SubscriptionDataSource.other:
      return 'Autre';
    case SubscriptionDataSource.outilinterne:
      return 'Outil interne';
    case SubscriptionDataSource.prospeneo:
      return 'Prospeneo';
    case SubscriptionDataSource.sweepbright:
      return 'Sweepbright';
    case SubscriptionDataSource.unova:
      return 'Unova';
    case SubscriptionDataSource.whise:
      return 'Whise';
    default:
      return '';
  }
}

export default SubscriptionDataSource
